<div class="content-experience content-experience--catalogue">
    <div class="content-experience__body">
        <div class="box box-experience">
            <div class="box-experience__title mb-3">
                <h3>{{ "words.banners-title" | translate }}</h3>
            </div>
            <div class="flex flex-row justify-between my-4 py-2 gap-4">

                <div class="flex items-center gap-2">
                    <span class="text-sm font-semibold text-gray-700">{{ "words.pick-a-banner-timer" | translate
                        }} : </span>
                    <msc-common-select class="msc-select--small w-[140px] text-sm " [data]="bannerTimers">
                        <ng-template #buttonTemplate let-data="data">
                            <button class="text-slate-500 truncate">
                                <span>{{currentBannerTimer}} {{'words.seconds' | translate}}</span>
                            </button>
                        </ng-template>
                        <ng-template #optionTemplate let-datum="datum">
                            <label class="flex w-full cursor-pointer" (click)="onSelectOptiontTimerBanner(datum)">
                                <span class="ml-2 text-sm truncate">{{ datum.label }}</span>
                            </label>
                        </ng-template>
                    </msc-common-select>
                </div>
                <msc-button class="msc-button--primary" icon="icon-plus" palette="secondary" (click)="openModalAdd()">
                    {{ "words.add" | translate }}
                </msc-button>
            </div>

            <div class="table-container overflow-x-auto bg-white border border-gray-50 shadow-sm">
                <table>
                    <thead class="box-experience__title sticky-top" style="position: sticky; top: 0; z-index: 10">
                        <tr>
                            <th>
                                <span>{{ "words.firstname" | translate }}</span>
                            </th>
                            <th>
                                <span>{{ "words.details" | translate }}</span>
                            </th>
                            <th>
                                <span>{{ "words.title" | translate }}</span>
                            </th>
                            <th>
                                <span>{{ "words.certificate-link" | translate }}</span>
                            </th>
                            <th>
                                <span class="flex justify-center items-center"
                                    [tooltip]="'words.start-date' | translate"><i
                                        class="fa fa-calendar-check"></i></span>
                            </th>
                            <th>
                                <span class="flex justify-center items-center"
                                    [tooltip]="'words.end-date' | translate"><i class="fa fa-calendar-times"></i></span>
                            </th>
                            <th>
                                <span></span>
                            </th>
                            <th>
                    </thead>
                    <ng-container *ngIf="isLoadingTable">
                        <msc-common-spinner></msc-common-spinner>
                    </ng-container>
                    <tbody *ngIf="!isLoadingTable">
                        <ng-container *ngFor="let banner of banners">
                            <tr>
                                <td><span class="clamp-2" [tooltip]="banner.name">{{ banner.name }}</span></td>
                                <td><span class="clamp-2" [tooltip]="banner.detail">{{ banner.detail }}</span></td>
                                <td><span class="clamp-2" [tooltip]="banner.title">{{ banner.title }}</span></td>
                                <td><span class="clamp-2" class="flex justify-center items-center">
                                        <ng-container>
                                            <i class="icon icon-eye  text-gray-500" [tooltip]="banner.actionUrl">
                                            </i>
                                        </ng-container>
                                    </span>
                                </td>
                                <td><span class="clamp-2" [tooltip]="'words.start-date' | translate">{{ banner.startAt |
                                        date }}</span></td>
                                <td><span class="clamp-2" [tooltip]="'words.end-date' | translate">{{ banner.endAt |
                                        date }}</span></td>
                                <td><span>
                                        <div class="flex flex-col gap-2 items-start">
                                            <msc-button class="msc-button--secondary mr-3" icon="icon-edit"
                                                palette="primary" [tooltip]="'words.edit' | translate"
                                                (click)="openEdit(banner)"></msc-button>

                                            <msc-button class="msc-button--primary" icon="icon-trash-2"
                                                palette="secondary" [tooltip]="'common.delete' | translate"
                                                (click)="openModalDelete(banner.id)"></msc-button>
                                        </div>
                                    </span>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <msc-common-modal size="40vw" #modalAdd
        [title]="isEdit ? ('words.banner-edit' | translate) : ('words.banner-create' | translate)">
        <ng-template>
            <ng-container *ngIf="isLoading">
                <msc-common-spinner></msc-common-spinner>
            </ng-container>
            <ng-container *ngIf="!isLoading && !hasError">
                <div class="flex flex-col gap-4 max-h-96 overflow-y-auto">
                    <span>{{'words.pick-a-content-type-to-continue' | translate}}</span>
                    <div class="flex flex-row items-center  gap-2">
                        <msc-common-select class="msc-select--small w-[200px] text-sm" [data]="contentTypes">
                            <ng-template #buttonTemplate let-data="data">
                                <button class="text-slate-500 truncate">
                                    <span *ngIf="selectedContentType === ''">{{'words.content-type' | translate}}</span>
                                    <span *ngIf="selectedContentType !== ''">{{selectedContentType}}</span>
                                </button>
                            </ng-template>
                            <ng-template #optionTemplate let-datum="datum">
                                <label class="flex w-full cursor-pointer" (click)="onSelectOption(datum)">
                                    <span class="ml-2 text-sm truncate">{{ datum.label }}</span>
                                </label>
                            </ng-template>
                        </msc-common-select>

                        <msc-button [disabled]="newBanner.contentType === 'other' || newBanner.contentType === ''"
                            (click)=" openModalContentSelection()">{{'words.pick-content' | translate}}</msc-button>

                               
                    </div>

                    <h4 class="font-bold mb-2">{{'words.banner-info' | translate}}</h4>

                    <div class="flex justify-between gap-4">
                        <div class="flex w-1/2 flex-col">
                            <msc-input [label]="'words.name' | translate" type="text" [(ngModel)]="newBanner.name"
                                placeholder="Name"></msc-input>
                        </div>
                        <div class="flex w-1/2 flex-col">
                            <msc-input [label]="'words.details' | translate" type="text" [(ngModel)]="newBanner.detail"
                                placeholder="Details"></msc-input>
                        </div>
                    </div>
                    <!--date-->

                    <div class="flex gap-4">
                        <div class="flex flex-col">
                            <label>{{'words.start-date' | translate}}</label>
                            <msc-input type="date" [(ngModel)]="newBanner.startAt"></msc-input>
                        </div>
                        <div class="flex flex-col">
                            <label>{{'words.end-date' | translate}}</label>
                            <msc-input type="date" [(ngModel)]="newBanner.endAt"></msc-input>
                        </div>
                    </div>
                    <!--
                <msc-input [label]="'words.duration' | translate" type="number"  [(ngModel)]="newBanner.duration" placeholder="Duration"></msc-input>
                -->

                      <!--inf public banner-->
                    <h4 class="font-bold mb-2"> {{'words.course-info-public' | translate}}</h4>

                    <msc-input [label]="'words.provider-name' | translate" type="text"
                        [(ngModel)]="newBanner.providerName" placeholder="Nombre del proveedor"
                        [disabled]="true"></msc-input>
                    <msc-input [label]="'words.title' | translate" type="text" [(ngModel)]="newBanner.title"
                        placeholder="Título"></msc-input>
                    <msc-input [label]="'words.description' | translate" type="text" [(ngModel)]="newBanner.description"
                        placeholder="Descripción"></msc-input>

                    <ng-container *ngIf="newBanner.contentType === 'other'">
                        <h4 class="font-bold mb-2">{{'words.banner-redirect-info' | translate}}</h4>
                        <msc-input [label]="'words.redirect-to-url' | translate" type="text"
                            [(ngModel)]="newBanner.actionUrl" placeholder="URL"></msc-input>
                        <div class="flex items-start gap-2">
                            <label for="fileInput">{{'words.upload-image' | translate}}</label>
                            <i class="icon icon-info ml-5 cursor-pointer" [tooltip]="'words.check-image-recommendations' | translate" (click)="openImageRecommendationsModal()"></i>
                        </div>
                        <input type="file" (change)="onFileSelected($event)" accept="image/*" name="fileInput"
                            #fileInput>
                    </ng-container>
                    <ng-container *ngIf="newBanner.contentType === 'other'">
                        <msc-input [label]="'words.button-name' | translate" type="text"
                            [(ngModel)]="newBanner.buttonLabel" placeholder="Button Label"></msc-input>
                            
                    </ng-container>

                    <!--
                <msc-input [label]="'words.redirect-to-type' | translate" type="text" [(ngModel)]="newBanner.actionType" placeholder="Tipo (e.g., external)"></msc-input>
                -->

                </div>
                <div class="flex items-center mt-5 space-x-5 justify-end">
                    <ng-container *ngIf="isLoadingImage">
                        <span>{{'words.image-uploading' | translate}}</span> 
                        <msc-common-spinner></msc-common-spinner>
                    </ng-container>

                    <msc-button palette="primary" (click)="modalAdd.onClose()">{{ "common.cancel" | translate
                        }}</msc-button>
                    <msc-button class="msc-button--primary" palette="primary" [disabled]="!isFormValid() || isLoadingImage || isLoading"
                        (click)="isEdit ? updateBanner() : createBanner()">{{ isEdit ? ("common.edit" | translate) :
                        ("common.save" | translate) }}</msc-button>
                </div>
            </ng-container>
            <ng-container *ngIf="!isLoading && hasError">
                <h2>{{ errorMsg | translate }}</h2>
            </ng-container>
        </ng-template>
    </msc-common-modal>

    <msc-common-modal size="20vw" #modalDelete [title]="'words.banner-delete-title' | translate">
        <ng-template>
            <span>{{ 'words.banner-delete-text' | translate }}</span>
            <div class="flex items-center mt-3 space-x-5 justify-start">
                <msc-button class="msc-button--primary mr-3" palette="primary" (click)="deleteBanner()">
                    {{ "common.delete" | translate }}
                </msc-button>
                <msc-button palette="primary" (click)="modalDelete.onClose()">
                    {{ "common.cancel" | translate }}
                </msc-button>
            </div>
        </ng-template>
    </msc-common-modal>

    <msc-common-modal size="80vw" #modalContentSelection [title]="'words.banner-select-content' | translate">
        <ng-template>
            <div class="mb-3 w-3/12 flex content-center gap-2">
                <msc-input [label]="'words.search' | translate" type="text" [(ngModel)]="searchTerm"
                    [placeholder]="'words.search' | translate"></msc-input>
                <msc-button palette="primary" (click)="getRecommendedContentByCompany()">
                    {{ "words.search" | translate }}
                </msc-button>
            </div>
            <span>{{ 'words.pick-content' | translate }}</span>
            <msc-common-spinner *ngIf="isLoading"></msc-common-spinner>
            <div *ngIf="!isLoading"
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-h-[600px] overflow-y-auto mt-3">
                <ng-container *ngFor="let content of recommendedContentByCompany">
                    <content-card [content]="content" [origin]="'bannerCreation'"
                        (onPickBannerElement)="onPickBannerElement($event)"></content-card>
                </ng-container>
            </div>

        </ng-template>
    </msc-common-modal>

    <msc-common-modal size="30vw" #modalImageRecommendations [title]="'words.image-recommendations' | translate">
        <ng-template>
            <div class="flex flex-col">
                <div class="flex items-center justify-start gap-2">
                    <div class="rounded-[100%] w-1 h-1 bg-black mr-2"></div>
                    <b>{{'words.dimensions' | translate}}:</b><span> 1920px x 1080px</span>
                </div>
                    <div class="flex items-center justify-start gap-2">
                    <div class="rounded-[100%] w-1 h-1 bg-black mr-2"></div>
                    <b>{{'words.format' | translate}}:</b><span> png, jpg {{'words.or' | translate}} webp</span>
                </div>
                    <div class="flex items-center justify-start gap-2">
                    <div class="rounded-[100%] w-1 h-1 bg-black mr-2"></div>
                    <b>{{'words.file-size' | translate}}:</b><span> ≤ 300kb</span>
                </div>
            </div>
        </ng-template>
    </msc-common-modal>